import styled from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100%;
  left: 0;
  top: 0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 1.7em;
  height: 100%;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.animated {
    animation-duration: 0.4s !important;
    animation-fill-mode: both;
  }

  &.fadeIn {
    z-index: 3;
    animation-name: fadeIn;
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }

  &.fadeOut {
    animation-name: fadeOut;
    z-index: -3;
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Spinner = styled.img`
  width: 30px;
  height: 30px;
  align-self: center;
`;

export const Text = styled.div`
  font-size: 0.7em;
  margin: 20px 0;
`;
